module.exports = __webpack_public_path__ + "static/media/ico_simulation_nose_root.19584011.png";